import type { ButtonHTMLAttributes } from "react";
import { useT } from "../../i18n/LanguageProvider";
import { ShopFloorIcon, type ShopFloorIconName } from "./ShopFloorIcon";

interface ShopFloorMenuButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  icon: ShopFloorIconName;
  label: string;
  notificationCount?: number;
  selected?: boolean;
  variant?: "default" | "lock";
}

export function ShopFloorMenuButton({
  icon,
  label,
  notificationCount = 0,
  selected = false,
  variant = "default",
  className,
  ...props
}: ShopFloorMenuButtonProps) {
  const { t } = useT();
  const classes = [
    "shop-floor-menu-button",
    selected ? "is-selected" : "",
    variant === "lock" ? "is-lock" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      aria-pressed={variant === "default" ? selected : undefined}
      {...props}
    >
      <span className="shop-floor-menu-button__icon">
        <ShopFloorIcon name={icon} size={25} />
      </span>
      <span className="shop-floor-menu-button__label">{label}</span>
      {notificationCount > 0 ? (
        <span
          className="badge danger shop-floor-menu-button__badge"
          aria-label={t("hub.notifications", { count: notificationCount })}
        >
          {notificationCount > 99 ? "99+" : notificationCount}
        </span>
      ) : null}
      <ShopFloorIcon
        name="chevron-right"
        size={21}
        className="shop-floor-menu-button__chevron"
      />
    </button>
  );
}
